<!-- 一般ユーザー　パスワード変更-->
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_mypage.css" type="text/css" media="all" scoped></style>
<style scoped>

</style>
<template>
  <div class="container" id="changePW">
    <div class="contents">
      <h2>マイページ</h2>
      <!-- ▽  -->
      <section id="mainContents">
        <section class="inputArea">
          <h3>【パスワード変更】</h3>
				  <p>パスワードは半角英数字で入力してください。</p>
				  <p>英字は大文字、小文字が区別されます。正確に入力してください。項目は全て必須入力です。</p>
          <section class="oldPW inputTbl">
					  <dl>
					  	<dt>現在のパスワード</dt>
					  	<dd><input type="text" v-model="inputForm.currentPassword"></dd>
					  </dl>
          </section>
          <p class="arw">▼</p>
				  <section class="newPW inputTbl">
				  	<dl>
				  		<dt>新規パスワード</dt>
				  		<dd>
				  			<ul>
				  				<li><input type="text" v-model="inputForm.newPassword"></li>
				  				<li><input type="text" v-model="inputForm.newPasswordEx"></li>
				  			</ul>
				  		</dd>
				  	</dl>
				  </section>
				  <div class="btnLst">
						<button class="cancelBtn" v-on:click="onCancel">キャンセル</button>
						<button class="confBtn" v-on:click="onChangePasswordConfirmModalOpen">設定する</button></div>
        </section>
        <!-- △  END -->
      </section>
      <!-- △ mainContents END -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.changePasswordConfirm.isShow" v-on:close="onChangePasswordConfirmModalClose">
        <dt slot="modal-header">パスワード変更確認</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.changePasswordConfirm.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer">
          <button class="cancelBtn" v-on:click="onChangePassword">変更する</button>
          <button class="backBtn" v-on:click="onChangePasswordConfirmModalClose">閉じる</button>
        </dd>
      </modalWindow>
      <!-- モーダルWindow S -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
        <dt slot="modal-header">入力エラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
        <dt slot="modal-header">システムエラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
    </div>
  </div>
</template>
<script>
  import { CommonChangePassword } from '@/api'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityValidation from '@/components/Utility/UtilitiValidation'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonChangePassword',
    // 使用コンポーネント
    components: {
      // エラー表示コンポーネント
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ表示コンポーネント
      modalWindow: ModalWindow
    },
    // データ
    data() {
      return {
        inputForm: {
          // 現在のパスワード
          currentPassword: '',
          // 新規パスワード
          newPassword: '',
          // 新規パスワード（確認用）
          newPasswordEx: ''
        },
        // モーダルウィンドウ
        modal: {
					// パスワード変更確認
					changePasswordConfirm: {
            messages: [
              'パスワードを変更します。'
            ],
            isShow: false
					},
					// 入力エラーダイアログ
          validationError: {
            messages: [],
            isShow: false
          },
					// システムエラーダイアログ
          systemError: {
            messages: [
              'システムエラーです。',
              '内容をもう一度ご確認ください。'
						],
            isShow: false
          }
        }
      }
    },
    // ライフサイクルフック: created
    created: function () {
      UtilityConsoleLog.consoleLog('CommonChangePassword::created Start')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('CommonChangePassword::created End')
    },
    methods: {
      // 表示系--------------------------------------------------S
      // 初期表示
      firstDisplay: function () {
        UtilityConsoleLog.consoleLog('CommonChangePassword::firstDisplay Start')

        UtilityConsoleLog.consoleLog('CommonChangePassword::firstDisplay End')
      },
			// 表示系--------------------------------------------------E
			// イベント系----------------------------------------------S
      // パスワード変更ダイアログでOKボタン押下時
      onChangePassword: function () {
        UtilityConsoleLog.consoleLog('CommonChangePassword::onChangePassword Start')

        CommonChangePassword.ChangePassword({
					token: this.$store.state.auth.token,
          userId: this.$store.state.auth.userId,
          currentPassword: this.inputForm.currentPassword, 
          newPassword: this.inputForm.newPassword,
          newPasswordEx: this.inputForm.newPasswordEx
        }).then(({ responce }) => {
          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            // パスワード変更結果画面に遷移する
						this.$router.push('/CommonChangePassword2')
          
          } else if(responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION
            || responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {
            // エラーダイアログを表示
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonChangePassword::onChangePassword End')
	      })
      },
      // キャンセルボタン押下時
      onCancel() {
        UtilityConsoleLog.consoleLog('CommonChangePassword::onCancel Start')

        // マイページ画面に遷移する
				this.$router.push('/CommonMyPage')

        UtilityConsoleLog.consoleLog('CommonChangePassword::onCancel End')
      },
			// イベント系----------------------------------------------E
      // その他--------------------------------------------------S
			validationOnChangePassword: function () {
				UtilityConsoleLog.consoleLog('CommonChangePassword::validationOnChangePassword Start')

        // エラーメッセージリスト
        var errorMessagesList = []

				var tempErrorMessage = []

        // 現在のパスワードチェック
        tempErrorMessage = this.validationPassword(
					'現在のパスワード',this.inputForm.currentPassword)
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 新規パスワードチェック
        tempErrorMessage = this.validationPassword(
					'新規パスワード',this.inputForm.newPassword)
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })

        // 新規パスワード（確認用）チェック
        tempErrorMessage = this.validationPassword(
					'新規パスワード（確認用）',this.inputForm.newPasswordEx)
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })

				// エラーがなければ相関チェック
				if(errorMessagesList.length == 0 ){
					if(this.newPassword != this.newPasswordEx) {
						errorMessagesList.push('新規パスワードと新規パスワード（確認用）が一致しません。')
					}
				}

				UtilityConsoleLog.consoleLog('CommonChangePassword::validationOnChangePassword End')

				return errorMessagesList
			},
      // パスワードチェック
      validationPassword: function (in_prppatyName,in_value) {

        UtilityConsoleLog.consoleLog('CommonTop::validationPassword Start')

        var propertyNamePassword = in_prppatyName

        // エラーメッセージリスト
        var errorMessagesList = []

        if (UtilityValidation.checkStrIsNull(in_value)) { // Nullチェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyNamePassword))
        } else if (UtilityValidation.checkStrIsKaraMoji(in_value)) { // 空文字チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
              propertyNamePassword))
        }

        UtilityConsoleLog.consoleLog('CommonTop::validationPassword End')

        return errorMessagesList
      },
      // パスワード変更確認モーダルとしてモーダルを開く
      onChangePasswordConfirmModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonChangePassword::onChangePasswordConfirmModalOpen Start')
        // エラーチェック
				var tempErrorMessageList = this.validationOnChangePassword()

        // ダイアログを表示
				if(tempErrorMessageList.length > 0) {
					this.onValidationErrorModalOpen(tempErrorMessageList)
          UtilityConsoleLog.consoleLog('CommonChangePassword::onChangePasswordConfirmModalOpen End')
          return
				}

        this.modalOpen('changePasswordConfirm')

        UtilityConsoleLog.consoleLog('CommonChangePassword::onChangePasswordConfirmModalOpen End')
      },
      // パスワード変更確認モーダルを閉じる
      onChangePasswordConfirmModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonForgetPassword::onChangePasswordConfirmModalClose Start')

        this.modalClose('changePasswordConfirm')

        UtilityConsoleLog.consoleLog('CommonForgetPassword::onChangePasswordConfirmModalClose End')
      },
      // バリデーションエラーモーダルとしてエラーモーダルを開く
      onValidationErrorModalOpen: function (errorMessages) {

        UtilityConsoleLog.consoleLog('CommonChangePassword::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
        this.modalOpen('validationError')

        UtilityConsoleLog.consoleLog('CommonChangePassword::onValidationErrorModalOpen End')
      },
      // バリデーションエラーモーダルを閉じる
      onValidationErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonChangePassword::onValidationErrorModalClose Start')

        this.modalClose('validationError')

        UtilityConsoleLog.consoleLog('CommonChangePassword::onValidationErrorModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonChangePassword::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('CommonChangePassword::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonChangePassword::onSystemErrorModalClose Start')

        this.modalClose('systemError')

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonChangePassword::onSystemErrorModalClose End')
      },
			modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonChangePassword::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('CommonChangePassword::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonChangePassword::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('CommonChangePassword::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
    }
		// その他--------------------------------------------------E
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/ChangePassword/CommonChangePassword.vue